var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25 0H10C4.47715 0 0 4.47715 0 10V25C0 30.5228 4.47715 35 10 35H25C30.5228 35 35 30.5228 35 25V10C35 4.47715 30.5228 0 25 0Z",
    fill: "#FFF595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1377 22.125V24.05",
    stroke: "#FFF595",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5537 27.167H21.7204V26.2503C21.7204 25.242 20.8954 24.417 19.887 24.417H14.387C13.3787 24.417 12.5537 25.242 12.5537 26.2503V27.167V27.167Z",
    stroke: "#FFF595",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6377 27.167H22.6377",
    stroke: "#FFF595",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9997 21.6663C13.4522 21.6663 10.583 18.7972 10.583 15.2497V12.4997C10.583 10.4738 12.2238 8.83301 14.2497 8.83301H19.7497C21.7755 8.83301 23.4163 10.4738 23.4163 12.4997V15.2497C23.4163 18.7972 20.5472 21.6663 16.9997 21.6663Z",
    stroke: "#FFF595",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.0143 17.679C10.3268 17.459 9.72178 17.0556 9.24512 16.579C8.42012 15.6623 7.87012 14.5623 7.87012 13.279C7.87012 11.9956 8.87845 10.9873 10.1618 10.9873H10.7576C10.5743 11.409 10.4826 11.8765 10.4826 12.3623V15.1123C10.4826 16.029 10.6751 16.8906 11.0143 17.679Z",
    stroke: "#FFF595",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.9854 17.679C23.6729 17.459 24.2779 17.0556 24.7545 16.579C25.5795 15.6623 26.1295 14.5623 26.1295 13.279C26.1295 11.9956 25.1212 10.9873 23.8379 10.9873H23.242C23.4254 11.409 23.517 11.8765 23.517 12.3623V15.1123C23.517 16.029 23.3245 16.8906 22.9854 17.679Z",
    stroke: "#FFF595",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.125878b2caa768a0a923049b84d7c353.svg";
export { ForwardRef as ReactComponent };